import { render, staticRenderFns } from "./gptTranslate.vue?vue&type=template&id=dbb193cc&scoped=true"
import script from "./gptTranslate.vue?vue&type=script&lang=js"
export * from "./gptTranslate.vue?vue&type=script&lang=js"
import style0 from "./gptTranslate.vue?vue&type=style&index=0&id=dbb193cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb193cc",
  null
  
)

export default component.exports